import { StaffUser, StaffAccessPolicy, StaffUserAccessLevel } from '../services/gqty'

/**
 * Transform a staff user to include computed fields
 */
export const transformUser = (user: StaffUser) => {
  return {
    ...user,
    id: user.staffUserId,
    name: `${user.firstName} ${user.lastName}`.trim(),
  }
}

/**
 * Map a staff user from query result row format
 */
export const staffUserMapper = ({ row: user }: { row: StaffUser }) => transformUser(user)

/**
 * Map an access policy to include only necessary fields
 */
export const accessPolicyMapper = ({
  staffAccessPolicyId,
  name,
  accessPermissions,
  corporatePermissions,
  sitePermissions,
}: StaffAccessPolicy) => ({
  staffAccessPolicyId,
  name,
  accessPermissions,
  corporatePermissions,
  sitePermissions,
})

/**
 * Compute access policies display string from user rules
 */
export const computeAccessPolicies = (user: any) => {
  return (
    user.rules
      ?.map((rule: any) => rule.policy?.name)
      .filter(Boolean)
      .join(', ') || ''
  )
}

/**
 * Compute sites display string from user rules
 */
export const computeSites = (user: any) => {
  return (
    user.rules
      ?.flatMap((rule: any) => rule.sites?.map((s: any) => s.name) || [])
      .filter(Boolean)
      .join(', ') || ''
  )
}

/**
 * Compute site groups display string from user rules
 */
export const computeSiteGroups = (user: any) => {
  return (
    user.rules
      ?.flatMap((rule: any) => rule.siteGroups?.map((g: any) => g.name) || [])
      .filter(Boolean)
      .join(', ') || ''
  )
}

/**
 * Format access level array to display string
 * @param accessLevel - Array of StaffUserAccessLevel values
 * @param t - Translation function
 * @returns Formatted comma-separated string of access levels
 */
export const formatAccessLevel = (
  accessLevel: StaffUserAccessLevel[],
  t: (key: string) => string
) => {
  if (!accessLevel || !Array.isArray(accessLevel)) return ''

  return accessLevel
    .map((level: StaffUserAccessLevel) => {
      if (level === StaffUserAccessLevel.corporate) {
        return t('common:levelAccess.brand')
      }
      if (level === StaffUserAccessLevel.sites) {
        return t('common:levelAccess.location')
      }
      return null
    })
    .filter(Boolean)
    .join(', ')
}
